<template>
  <d-modal
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.differentsPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table
        v-if="dataToDisplay.length"
        class="table">
        <thead>
          <tr>
            <th style="width: calc(100% - 360px);" class="pl-4">{{ $t('order.differentsPopup.productName') }}</th>
            <th style="width: 180px;">{{ $t('order.differentsPopup.orderQty') }}</th>
            <th style="width: 180px;">{{ $t('order.differentsPopup.boxesQty') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of dataToDisplay"
            :key="'differents-row-' + index">
            <td class="pl-4">
              {{ row.product_name }}
            </td>
            <td>
              {{ row.order_quantity }} {{ $t('ui.piecesAbbr') }}
            </td>
            <td>
              {{ row.boxes_quantity }} {{ $t('ui.piecesAbbr') }}
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'order-differents-popup',
  props: [
    'dataToDisplay'
  ],
  methods: {
    handleClose () {
      this.$bus.$emit('order-creator-differents-popup-close');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
